import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import {
  avatar05,
  avatar06,
  avatar09,
  avatar10,
  avatar11,
  avatar13,
  avatar14,
  blogdetail,
} from "../../components/imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { hooks } from "../../studentportal-sdk";
import QuizCreator from "./QuizCreator";
import QuizTaker from "./QuizTaker";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import SideBar from "../../components/SideBar/AdminSideBar";


const Assessmentdetails = (props) => {
  const {
    assessmentService: {
      store: { assessmentDoc, questionDocs, timer },
      action:{ sendAnswer}
    },
  } = props;

  const role = localStorage.getItem("role")


  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        {role === "admin" && <SideBar />
}
          {role === "user" && <CourseSidebar />}


        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row ">
              <div className="col-lg-10 col-xl-9">
                {/* Blog Details*/}
                <div className="blog-view">
                  <div className="blog-single-post">
                    <Link to="/assessments" className="back-btn">
                      <i className="feather-chevron-left">
                        <FeatherIcon icon="chevron-left" />
                        Back
                      </i>
                    </Link>
                    <QuizTaker quizData={questionDocs} submitAnswer={sendAnswer} timerDoc={timer} />
                    <h3 className="blog-title">{assessmentDoc?.title}</h3>
 
                  </div>
                 
                </div>
              </div>
            </div>
            {/* /Blog Details*/}
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default (props) => <Assessmentdetails {...hooks.assessment(props)} />;
